import { isEmpty } from 'lodash'
import { fetchAttributes } from '../helpers/api'
import { COLLECTIONS } from '../helpers/constants'

export default class AttrsFilter {
  constructor (options) {
    this._filter = document.getElementById('attrs-filter')
    this.filter = { attributes: undefined }
    this.collection = options?.collection || COLLECTIONS.PLACES
  }

  static get EVENT () {
    return {
      CHANGE: 'poin:attrsFilter:change',
      OPEN: 'poin:attrsFilter:open',
      CLOSE: 'poin:attrsFilter:close'
    }
  }

  async init () {
    this.attributes = await fetchAttributes(this.collection)
    this._list = document.getElementById('attrs-filter-list')
    this.attributes.forEach((_attr) => {
      const container = document.createElement('div')
      const option = document.createElement('input')
      const label = document.createElement('label')

      option.type = 'checkbox'
      option.id = `${_attr.code_name}-option`
      option.className = 'attr-checkbox'
      option.name = 'attr'
      option.value = _attr.code_name
      option.addEventListener('change', (event) => {
        if (option.checked) {
          document.getElementById(`${event.target.value}-label`).style.fontWeight = 600
          this.filter.attributes = this.filter.attributes ? this.filter.attributes : {}
          this.filter.attributes[event.target.value] = true
        } else {
          document.getElementById(`${event.target.value}-label`).style.fontWeight = 400
          delete this.filter.attributes[event.target.value]
          this.filter.attributes = !isEmpty(this.filter.attributes) ? this.filter.attributes : undefined
        }
        this._filter.dispatchEvent(new Event(AttrsFilter.EVENT.CHANGE, { bubbles: true }))
      })

      label.id = `${_attr.code_name}-label`
      label.htmlFor = option.id
      label.textContent = _attr.human_name

      container.classList.add('attr-option')
      container.appendChild(option)
      container.appendChild(label)
      this._list.appendChild(container)
    })

    const queryParams = new URLSearchParams(window.location.search)
    const attrs = JSON.parse(queryParams.get('attributes'))

    if (attrs) {
      this.filter.attributes = attrs
      for (let [key, value] of Object.entries(attrs)) { //eslint-disable-line
        const option = document.getElementById(`${key}-option`)
        const label = document.getElementById(`${key}-label`)
        if (value) {
          if (option) option.checked = true
          if (label) label.style.fontWeight = 600
        }
      }
    }
  }

  close () {
    this._removeOptionListeners()
  }

  filterIsSet () {
    return Boolean(this.filter.attributes)
  }

  clean () {
    for (const option of document.querySelectorAll('.attr-checkbox')) { option.checked = false }
    for (const label of this._list.getElementsByTagName('label')) { label.style.fontWeight = 400 }

    this.filter.attributes = undefined
    this._filter.dispatchEvent(new Event(AttrsFilter.EVENT.CHANGE, { bubbles: true }))
  }
}
